import script from "./VerificationPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerificationPanel.vue?vue&type=script&setup=true&lang=ts"

import "./VerificationPanel.vue?vue&type=style&index=0&id=1d92c4df&lang=scss"

const __exports__ = script;

export default __exports__